import React from 'react';
var ThreeQuarters = function () {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "14px", height: "14px", viewBox: "0 0 14 14", version: "1.1", role: "img" },
        React.createElement("title", null, "Harvey Ball Three Quarters"),
        React.createElement("desc", null, "Three Quarters."),
        React.createElement("defs", null,
            React.createElement("rect", { id: "path-1", x: "0", y: "0", width: "14", height: "14", rx: "7" })),
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("mask", { id: "mask-2", fill: "white" },
                    React.createElement("use", { xlinkHref: "#path-1" })),
                React.createElement("use", { id: "Mask", fill: "#CCCCCC", xlinkHref: "#path-1" }),
                React.createElement("polygon", { id: "Rectangle-3", fill: "#444444", mask: "url(#mask-2)", points: "7 -1.77635684e-15 14 -1.77635684e-15 14 14 0 14 0 7 7 7" })))));
};
export default ThreeQuarters;
